module.exports = __webpack_public_path__ + "img/pig.50059921.png";